import Repository from '../repository';
import store from '../store';

const resource = '/product-category';

export default {
  get(params = {}) {
    return Repository.get(`${resource}`, {
      params: {
        lang: store.getters['auth/user'].locale || 'th',
        ...params,
      },
    });
  },
  getBySlug(slug, params = {}) {
    return Repository.get(`${resource}/${slug}`, {
      params: {
        lang: store.getters['auth/user'].locale || 'th',
        ...params,
      },
    });
  },
};
